
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import KeyGroupCreation from "@/components/key-groups/KeyGroupCreation.vue";
import {Getter} from "vuex-class";
import { ROWS_PER_PAGE } from "@/utils/constants";
const septeoImage = require("@/assets/images/septeo.png");

@Component({
    components: {
        KeyGroupCreation,
    },
})
export default class KeyGroups extends Vue {

    @Prop({default: null})
    public building?: any;

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;
    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private keyGroups: Array<{
      name: string,
      createdAt: string,
    }> = [];
    private headers: object[] = [
        {value: "name", sortable: false},
        {value: "createdAt", sortable: false},
        {value: "septeo", sortable: false},
    ];
    private loading: boolean = false;
    private pagination: any = {
        sortDesc: [false],
        sortBy: [""],
        search: "",
        page: 1,
        itemsPerPage: 10,
    };
    private totalItems: number = 0;
    private displayCreateKeyGroupDialog: boolean = false;
    private groupSearch: string = "";
    private septeoImage = septeoImage;

    private ROWS_PER_PAGE = ROWS_PER_PAGE;

    @Watch("pagination", {deep: true, immediate: false})
    public handler() {
        if (!this.loading) {
            if (this.isMobile) {
              this.reset();
            } else {
              this.fetchKeyGroups();
            }
        }
    }

    get allKeyGroupsFetch(): boolean {
        return this.totalItems === this.keyGroups?.length;
    }

    get canCreateGroup(): boolean {
      return this.canDoInEnvCompany("MANAGE_KEY_GROUPS");
    }

    private enterKeyPress(e) {
      if (e.keyCode === 13) {
        this.searchHandler();
      }
    }

    private searchHandler(): void {
      this.pagination.search = this.groupSearch || null;
      this.pagination.page = 1;
    }

    private mounted() {
        if (this.isMobile) {
          this.initScroll();
        }
        this.reset();
    }

    private handleClickRow(item): void {
        this.$router.push({name: "key-group", params: {id: item.id}});
    }

    private async reset(): Promise<void> {
      // Reset page param
      this.pagination.page = 1;
      // Fetch key groups
      await this.fetchKeyGroups();
    }

    private async fetchKeyGroups(): Promise<void> {
      // Reset key groups
      this.keyGroups = [];
      // Fetch first key groups
      await this.getKeyGroups().then((res) => {
        this.keyGroups = res.rows;
        this.totalItems = res.count;
      });
    }

    private async fetchNextKeyGroups(): Promise<void> {
      // Increment page param
      this.pagination.page += 1;
      // Fetch new key groups and concat
      await this.getKeyGroups().then((res) => {
        this.keyGroups = [
          ...this.keyGroups,
          ...res.rows,
        ];
        // No need to update totalItems since it shouldn't have changed
      });
    }

    private async getKeyGroups(): Promise<{ rows: any[], count: number }> {
        this.loading = true;
        return this.$store.dispatch("keyGroups/readAll", {
          page: this.pagination.page,
          itemsPerPage: this.pagination.itemsPerPage,
          search: this.pagination.search,
          buildingId: this.building?.id,
        }).finally(() => {
          this.loading = false;
          this.$emit("loaded");
        });
    }

    private toggleCreateKeyGroups() {
        this.displayCreateKeyGroupDialog = !this.displayCreateKeyGroupDialog;
    }

    private initScroll() {
        window.addEventListener("scroll", async (): Promise<void> => {
            const listElm = document.querySelector("#key-groups-list");
            const currentScrollValue: number = document.documentElement.scrollTop;
            const threshold: number = listElm?.clientHeight - window.innerHeight - 1000;
            const isTargetPos: boolean = currentScrollValue > threshold;
            if (isTargetPos && !this.loading && !this.allKeyGroupsFetch) {
              await this.fetchNextKeyGroups();
            }
        });
    }
}
